<div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-lg bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto custom-scrollbar">

    <div *ngIf="isLoading()"
      class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">admin_panel_settings</span>
        {{ formData.id ? 'แก้ไข Role' : 'สร้าง Role ใหม่' }}
      </h3>
      <button (click)="onClose()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-50 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-5">
      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อ Role <span
            class="text-rose-500">*</span></label>
        <div
          class="relative w-full flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:bg-white focus-within:ring-2 focus-within:ring-amber-200 transition-all overflow-hidden h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400">badge</span>
          <input type="text" placeholder="ตัวอย่าง: Manager" [(ngModel)]="formData.name"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:ring-0 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-3">สิทธิ์การใช้งาน</label>
        <div class="grid grid-cols-2 gap-3">
          <label
            class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.viewer"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">ดู (Viewer)</span>
          </label>
          <label
            class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.canCreate"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">สร้าง</span>
          </label>
          <label
            class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.canEdit"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">แก้ไข</span>
          </label>
          <label
            class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.canDelete"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">ลบ</span>
          </label>
          <div
            class="flex flex-col items-start w-full bg-slate-50dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300   transition-colors p-3 gap-1">
            <label class="w-full flex items-center gap-3 ">

              <input type="checkbox" [(ngModel)]="formData.canMenuRole"
                class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
              <span class="text-sm font-medium text-slate-700 dark:text-slate-300">จัดการเมนู Role</span>
            </label>
            <span
              class="text-[10px] text-slate-400 dark:text-slate-500">*เป็นการกำหนดสิทธิ์ดูตามสิทธิ์ในแต่ล่ะเมนู</span>
          </div>
          <label
            class="flex items-center gap-3 p-3 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800 cursor-pointer hover:border-amber-300 transition-colors">
            <input type="checkbox" [(ngModel)]="formData.approve"
              class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400">
            <span class="text-sm font-medium text-slate-700 dark:text-slate-300">อนุมัติ</span>
          </label>
        </div>
      </div>

      <div
        class="flex items-center justify-between p-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-100 dark:border-slate-800">
        <div>
          <h4 class="text-sm font-bold text-slate-700 dark:text-slate-300">เปิดใช้งาน Role</h4>
          <p class="text-[11px] text-slate-400 mt-0.5">เปิดหรือปิดการใช้งาน Role นี้</p>
        </div>
        <div class="relative inline-flex items-center cursor-pointer" (click)="formData.status = !formData.status">
          <input type="checkbox" class="sr-only peer" [checked]="formData.status">
          <div
            class="w-11 h-6 bg-slate-200 peer-focus:outline-none dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-slate-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500 rounded-full shadow-inner">
          </div>
        </div>
      </div>
    </div>

    <div class="flex items-center justify-between gap-3 mt-8 pt-4 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
        class="px-5 py-2.5 border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 text-slate-600 dark:text-slate-300 font-bold rounded-xl shadow-sm transition-all active:scale-95 inline-flex items-center gap-1.5 cursor-pointer">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <div class="flex items-center justify-end gap-3 ml-auto">
        <button (click)="onClose()"
          class="px-5 py-2.5 bg-slate-50 dark:bg-slate-800 hover:bg-slate-100 text-slate-500 dark:text-slate-400 font-bold rounded-xl shadow-sm transition-all active:scale-95">ยกเลิก</button>
        <button (click)="onSave()"
          class="px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-amber-400/20 hover:-translate-y-0.5 transition-all active:scale-95">บันทึก</button>
      </div>
    </div>
  </div>
</div>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && formData.id"
  [entityType]="activityEntityTypes.Role"
  [entityId]="formData.id!"
  title="ประวัติ Role"
  [subtitle]="'#' + formData.id"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>